import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import FlutterConfig from './FlutterConfig';
import { restrictUrls } from '../../../helpers/adminPrivileges';

const title = 'Flutter Remote Config';

export default async function action({ store }) {
  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  // Admin restriction - use same privilege as site settings (id 15)
  if (!restrictUrls('/siteadmin/settings/site', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: (
      <AdminLayout>
        <FlutterConfig title={title} />
      </AdminLayout>
    ),
  };
}
